import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import {
    Card,
    Grid,
    Header,
    Image,
    Segment,
    Dropdown
} from "semantic-ui-react";
import CardImage from "../Images/culture.jpg";
import {
    selectedTest,
    selectedCategory
} from "../../features/selections/selectActions";
// import { category } from "../ExperimentPage/Category";

// const panes = [
//     { menuItem: "All Tests", pane: { key: "allTests" } },
//     { menuItem: "Category1", pane: { key: "category1" } }
//     // { menuItem: "Category2", pane: { key: "category2" } },
//     // { menuItem: "Category3", pane: { key: "category3" } }
// ];

const mapState = state => ({
    selectedCollection: state.selection.selectedCategory,
    selectedTest: state.selection.selectedTest,
    testAttended: state.userDetail.testAttended
});

const actions = {
    selectedTest,
    selectedCategory
};

class UserDeteiledTests extends Component {
    state = {
        selectedSubject: "All"
    };

    options = [
        {
            key: "Category1",
            text: "Category1",
            value: "Category1"
        },
        {
            key: "Category2",
            text: "Category2",
            value: "Category2"
        },
        {
            key: "Category3",
            text: "Category3",
            value: "Category3"
        },
        {
            key: "All",
            text: "All",
            value: "All"
        }
    ];

    handleSelectValue = async (event, data) => {
        const { profile, getAttendedTest, getSubjectWiseTest } = this.props;
        console.log("handleSelectValue() value ", data.value);
        this.setState({
            selectedSubject: data.value
        });
        if (data.value === "All") {
            await getAttendedTest(profile.id);
        } else {
            await getSubjectWiseTest(profile.id, data.value);
        }
    };

    redirectToTest = (testId, testCollection) => () => {
        const { selectedTest, selectedCategory } = this.props;
        selectedTest(testId);
        selectedCategory(testCollection);

        this.props.history.push({
            pathname: "/testDetailPage"
        });
    };

    render() {
        const { testAttended, testLoading } = this.props;

        // console.log("profile ", profile);
        // console.log("getAttendedTest ", getAttendedTest);
        // console.log("getSubjectWiseTest ", getSubjectWiseTest);
        return (
            <Grid.Column width={16}>
                <Segment attached loading={testLoading}>
                    <Header icon="pencil" content="Tests" />
                    {/* <Tab
                        // onTabChange={(e, data) => changeTab(e, data)}
                        panes={panes}
                        menu={{ secondary: true, pointing: true }}
                    /> */}
                    <Dropdown
                        placeholder="Subject"
                        search
                        selection
                        value={this.state.selectedSubject}
                        options={this.options}
                        onChange={this.handleSelectValue}
                        style={{
                            width: "80%",
                            marginTop: "20px",
                            marginBottom: "30px"
                        }}
                    />
                    <br />

                    <Card.Group itemsPerRow={5} stackable>
                        {testAttended &&
                            testAttended.map(test => (
                                <Card
                                    onClick={this.redirectToTest(
                                        test.testId,
                                        test.testCollection
                                    )}
                                    key={test.testId}
                                >
                                    <Image src={CardImage} />
                                    <Card.Content>
                                        <Card.Header textAlign="center">
                                            {test.testId}
                                        </Card.Header>
                                        <Card.Meta textAlign="center">
                                            <div>{test.testCollection}</div>
                                            <div>{`score: ${
                                                test.testScore
                                            }`}</div>
                                        </Card.Meta>
                                    </Card.Content>
                                </Card>
                            ))}
                        {testAttended.length === 0 && (
                            <div
                                style={{
                                    margin: "50px",
                                    color: "red"
                                }}
                            >
                                <h2>No test attended in this subject yet.</h2>
                            </div>
                        )}
                    </Card.Group>
                </Segment>
            </Grid.Column>
        );
    }
}

export default withRouter(
    connect(
        mapState,
        actions
    )(UserDeteiledTests)
);
